export const guruUser = {
  id: 10,
  role: "GURU",
  nama: "Ibu Sari Wulandari",
  email: "sari.guru@example.sch.id",
  nip: "198705122010012003",
  mataPelajaran: ["Matematika", "IPA"],
};

export const adminUser = {
  id: 1,
  role: "ADMIN",
  nama: "Admin Sekolah",
  email: "admin@example.sch.id",
  nip: "ADM-001",
};

export const teacherExams = [
  {
    id: "g-mtk-01",
    namaUjian: "Penilaian Matematika Semester Genap",
    mataPelajaran: "Matematika",
    status: "published",
    tanggalMulai: "2026-06-20T08:00",
    tanggalSelesai: "2026-06-20T12:00",
    durasiMenit: 90,
    totalSiswa: 86,
    submitted: 73,
    rataRata: 81,
    passingGrade: 75,
    randomSoal: true,
    showHasilAfter: true,
    allowReview: true,
  },
  {
    id: "g-ipa-01",
    namaUjian: "Latihan IPA - Sistem Tata Surya",
    mataPelajaran: "IPA",
    status: "draft",
    tanggalMulai: "2026-06-23T09:00",
    tanggalSelesai: "2026-06-23T11:00",
    durasiMenit: 75,
    totalSiswa: 86,
    submitted: 0,
    rataRata: 0,
    passingGrade: 70,
    randomSoal: false,
    showHasilAfter: false,
    allowReview: false,
  },
  {
    id: "g-bindo-01",
    namaUjian: "Ulangan Bahasa Indonesia",
    mataPelajaran: "Bahasa Indonesia",
    status: "archive",
    tanggalMulai: "2026-06-12T08:00",
    tanggalSelesai: "2026-06-12T09:30",
    durasiMenit: 90,
    totalSiswa: 84,
    submitted: 84,
    rataRata: 78,
    passingGrade: 72,
    randomSoal: true,
    showHasilAfter: true,
    allowReview: true,
  },
];

export const teacherResults = [
  {
    id: "r1",
    nis: "12345678901",
    nama: "Nadia Putri Lestari",
    kelas: "VI A",
    nilai: 92,
    status: "submitted",
    durasiMenit: 68,
    waktuSubmit: "2026-06-20 09:14",
  },
  {
    id: "r2",
    nis: "12345678902",
    nama: "Bima Arya",
    kelas: "VI A",
    nilai: 84,
    status: "submitted",
    durasiMenit: 76,
    waktuSubmit: "2026-06-20 09:22",
  },
  {
    id: "r3",
    nis: "12345678903",
    nama: "Citra Lestari",
    kelas: "VI B",
    nilai: 61,
    status: "submitted",
    durasiMenit: 88,
    waktuSubmit: "2026-06-20 09:31",
  },
  {
    id: "r4",
    nis: "12345678904",
    nama: "Daffa Pratama",
    kelas: "VI B",
    nilai: 0,
    status: "incomplete",
    durasiMenit: 34,
    waktuSubmit: "-",
  },
  {
    id: "r5",
    nis: "12345678905",
    nama: "Elisa Rahma",
    kelas: "VI A",
    nilai: 0,
    status: "draft",
    durasiMenit: 0,
    waktuSubmit: "-",
  },
  {
    id: "r6",
    nis: "12345678906",
    nama: "Fajar Nugroho",
    kelas: "VI C",
    nilai: 77,
    status: "submitted",
    durasiMenit: 82,
    waktuSubmit: "2026-06-20 09:38",
  },
];

export const scoreDistribution = [
  { label: "0-49", count: 3 },
  { label: "50-59", count: 6 },
  { label: "60-69", count: 12 },
  { label: "70-79", count: 22 },
  { label: "80-89", count: 26 },
  { label: "90-100", count: 14 },
];

export const recentActivities = [
  { id: 1, user: "Nadia Putri", action: "selesai ujian", time: "2 menit lalu", score: 92 },
  { id: 2, user: "Bima Arya", action: "submit jawaban", time: "8 menit lalu", score: 84 },
  { id: 3, user: "Citra Lestari", action: "butuh review", time: "13 menit lalu", score: 61 },
  { id: 4, user: "Fajar Nugroho", action: "selesai ujian", time: "18 menit lalu", score: 77 },
];

export const itemAnalysis = [
  { no: 1, correctRate: 94, difficulty: "Mudah", topic: "Pecahan" },
  { no: 2, correctRate: 81, difficulty: "Sedang", topic: "Bangun ruang" },
  { no: 3, correctRate: 72, difficulty: "Sedang", topic: "Statistika" },
  { no: 4, correctRate: 48, difficulty: "Sulit", topic: "Perbandingan" },
  { no: 5, correctRate: 43, difficulty: "Sulit", topic: "Persentase" },
  { no: 6, correctRate: 68, difficulty: "Sedang", topic: "Rata-rata" },
];

export const systemStats = {
  siswa: 428,
  guru: 24,
  ujian: 38,
  responses: 1294,
  apiUptime: "99.98%",
  databaseStatus: "Healthy",
  storageUsage: 68,
};

export const students = [
  {
    id: 1,
    nis: "12345678901",
    nama: "Nadia Putri Lestari",
    kelas: "VI A",
    email: "nadia@example.sch.id",
    status: "aktif",
    terakhirLogin: "2026-06-20 07:42",
  },
  {
    id: 2,
    nis: "12345678902",
    nama: "Bima Arya",
    kelas: "VI A",
    email: "bima@example.sch.id",
    status: "aktif",
    terakhirLogin: "2026-06-20 07:55",
  },
  {
    id: 3,
    nis: "12345678903",
    nama: "Citra Lestari",
    kelas: "VI B",
    email: "citra@example.sch.id",
    status: "nonaktif",
    terakhirLogin: "2026-06-11 10:20",
  },
  {
    id: 4,
    nis: "12345678904",
    nama: "Daffa Pratama",
    kelas: "VI B",
    email: "daffa@example.sch.id",
    status: "aktif",
    terakhirLogin: "2026-06-20 08:02",
  },
  {
    id: 5,
    nis: "12345678905",
    nama: "Elisa Rahma",
    kelas: "VI C",
    email: "elisa@example.sch.id",
    status: "aktif",
    terakhirLogin: "2026-06-18 09:12",
  },
];

export const teachers = [
  {
    id: 1,
    nip: "198705122010012003",
    nama: "Ibu Sari Wulandari",
    email: "sari.guru@example.sch.id",
    role: "guru",
    status: "aktif",
    mataPelajaran: "Matematika",
  },
  {
    id: 2,
    nip: "198411032009011002",
    nama: "Pak Arif Hidayat",
    email: "arif.guru@example.sch.id",
    role: "guru",
    status: "aktif",
    mataPelajaran: "IPA",
  },
  {
    id: 3,
    nip: "197912212006042001",
    nama: "Ibu Rina Maharani",
    email: "rina.guru@example.sch.id",
    role: "admin",
    status: "aktif",
    mataPelajaran: "Kurikulum",
  },
];

export const questionBank = [
  {
    id: "b1",
    mataPelajaran: "Matematika",
    tipe: "Pilihan Ganda",
    kesulitan: "Sedang",
    pertanyaan: "Hasil dari 3/4 + 2/8 adalah ...",
    digunakan: 4,
  },
  {
    id: "b2",
    mataPelajaran: "IPA",
    tipe: "Pilihan Ganda",
    kesulitan: "Mudah",
    pertanyaan: "Planet terdekat dari matahari adalah ...",
    digunakan: 2,
  },
  {
    id: "b3",
    mataPelajaran: "Bahasa Indonesia",
    tipe: "Isian",
    kesulitan: "Sulit",
    pertanyaan: "Tuliskan ide pokok paragraf berikut ...",
    digunakan: 1,
  },
];

export const classes = [
  { id: "6a", nama: "VI A", waliKelas: "Ibu Sari Wulandari", jumlahSiswa: 31 },
  { id: "6b", nama: "VI B", waliKelas: "Pak Arif Hidayat", jumlahSiswa: 29 },
  { id: "6c", nama: "VI C", waliKelas: "Ibu Rina Maharani", jumlahSiswa: 30 },
  { id: "5a", nama: "V A", waliKelas: "Pak Bagus Prasetyo", jumlahSiswa: 32 },
];

export const schoolWideReports = [
  { mapel: "Matematika", peserta: 256, rataRata: 78, passRate: 82 },
  { mapel: "IPA", peserta: 238, rataRata: 81, passRate: 86 },
  { mapel: "Bahasa Indonesia", peserta: 244, rataRata: 84, passRate: 91 },
  { mapel: "PPKn", peserta: 226, rataRata: 80, passRate: 88 },
];
